import {FormDrawer} from "./FormDrawer.tsx";
import {DrawerProps} from "@mantine/core";
import {useParams} from "react-router-dom";
import {useCustomerSubscription} from "../hooks/useCustomerSubscription.ts";
import {CustomerSubscription, CustomerSubscriptionStatus} from "../types.ts";

export const AddFormDrawer = (props: DrawerProps) => {
    const {id: customerId} = useParams();

    const {
        createRecord,
    } = useCustomerSubscription();

    return (
        <FormDrawer
            record={{
                id: '',
                customerId: customerId || '',
                items: {items: []},
                status: CustomerSubscriptionStatus.Active,
            } as CustomerSubscription}
            handleSubmit={createRecord}
            {...props}
        />
    );
};
